import { useCallback } from 'react'
import TagManager from 'react-gtm-module'
import styles from './klassDetail.module.scss'
import useMetaApi from 'app/school/hooks/useMetaApi'
interface IApplyButtonProps {
  klassId: string
  disabled: boolean
  name: string
  handler: () => void
  isApplying: boolean
}

const ApplyButton = ({ klassId, disabled, handler, name, isApplying }: IApplyButtonProps) => {
  const { onMetaEvent } = useMetaApi('kdt_apply_btn_click')
  const actionHandler = useCallback(() => {
    if (isApplying) {
      onMetaEvent()
      TagManager.dataLayer({
        dataLayer: {
          event: 'kdt_apply_btn_click',
          content_ids: klassId,
          ...(sessionStorage.getItem('utmAndGclid') &&
            JSON.parse(sessionStorage.getItem('utmAndGclid') as string)),
        },
      })
    }
    handler()
  }, [handler, klassId, isApplying, onMetaEvent])
  return (
    <button
      disabled={disabled}
      onClick={actionHandler}
      className={`flex w-full items-center justify-center rounded-md py-2 lg:py-3 ${disabled ? 'cursor-not-allowed bg-[#DADADA]' : 'bg-yellow-450'}`}
    >
      <span
        className={`text-base font-semibold lg:text-lg ${disabled ? 'text-label-alternative' : 'text-white'}`}
      >
        {name}
      </span>
      <span
        className={`${styles.apply_btn_icon_arrow} ml-1.5 h-4 w-4 text-white lg:hidden ${disabled ? 'hidden' : 'inline-block'}`}
      >
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.23441 2.63434C8.54683 2.32192 9.05336 2.32192 9.36578 2.63434L14.1658 7.43434C14.4782 7.74676 14.4782 8.25329 14.1658 8.56571L9.36578 13.3657C9.05336 13.6781 8.54683 13.6781 8.23441 13.3657C7.92199 13.0533 7.92199 12.5468 8.23441 12.2343L11.6687 8.80002L2.4001 8.80003C1.95827 8.80002 1.6001 8.44185 1.6001 8.00002C1.6001 7.5582 1.95827 7.20002 2.4001 7.20002H11.6687L8.23441 3.76571C7.92199 3.45329 7.92199 2.94676 8.23441 2.63434Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </button>
  )
}

export default ApplyButton
